<template>
    <div style="background: #fff!important; position: absolute; top: 0px; bottom: 0px; left: 0; right: 0; padding: 0; display: flex; flex-direction: column;">
        <div style="border-bottom: 1px solid #f6f6f6; text-align: center; padding:10px 15px; box-shadow: 0 0 10px rgba(0,0,0,.08); background: #f1f1f1!important; color: #000;">
            <span style="font-weight: 600" class="gallery--title-head">{{ title }}</span>
        </div>

        <div style="flex-grow: 1; flex-shrink: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">
            <pm-gallery-media-list @open="openViewer" :id="id" ref="mediaList"/>
        </div>

        <pm-premium-lock-screen v-if="!$IAP.hasAccessToComponent('photos')" track-label="lock_screen_photos" />


    </div>
</template>

<style>
@media (min-width: 700px) {
    .gallery--title-head {
        font-size: 18px;
    }
}
</style>

<script>
import childCategories from "../../configs/gallery/child-categories.json";
import mixinComputedTitle from "./mixin-computed-title";
import PmGalleryMediaList from "./media-list";
import PmPremiumLockScreen from "@/components/core/premium-lock-screen";

export default {
    name: "PmModGallery",
    mixins: [
        mixinComputedTitle
    ],
    components: {
        PmGalleryMediaList,
        PmPremiumLockScreen,
    },
    props: {
        id: {
            type: Number,
        }
    },
    computed: {
        settings() {
            return childCategories.filter(i => i.id === this.id)[0];
        },
    },
    methods: {
        reload() {
            this.$refs['mediaList'].reload();
        },
        openViewer(params) {
            const [idx, tag, items] = params;
            let flatItems = [];
            let listIdx = -1;
            let i = 0;
            const favourites = items['favourites'] ? items['favourites'].length : 0;
            Object.keys(items).forEach((key) => {
                if (listIdx < 0) {
                    if (tag !== key) i += items[key].length;
                    else listIdx = i + idx;
                }
                flatItems.push(...items[key]);
            });

            const finalParams = {
                start: listIdx,
                items: flatItems,
                galleryId: this.id,
                galleryTitle: this.title,
                favourites: favourites,
            }

            this.$emit('openViewer', finalParams);
        },
    },
};

</script>
